import request from '../../axios';
import {IPatchStoreAdPayload} from './usePatchStoreAd';

export const patchStoreAd = async (payload: IPatchStoreAdPayload) => {
  const {data} = await request.patch(
    `/api/v2/store/update-advertisement-quantity/${payload.advertisementGuid}`,
    {available_quantity: payload?.availableQuantity},
  );
  return data;
};
